@if (!pdf) {
    <dsn-tabs [size]="'small'">
        <dsn-tab
            [disabled]="loading()"
            [active]="tabActive === 'period'"
            (click)="onChangeTab('period')"
            >{{ labelPeriod() }}</dsn-tab
        >
        <dsn-tab
            [active]="tabActive === 'accumulated'"
            (click)="onChangeTab('accumulated')"
            [disabled]="options?.comparation?.active || loading()"
            >Acumulado</dsn-tab
        >
    </dsn-tabs>
} @else {
    @if (tabActive === "period") {
        <span class="text-14-semi-bold color-text-strong">{{
            labelPeriodPdf()
        }}</span>
    } @else {
        <span class="text-14-semi-bold color-text-strong"
            >DRE {{ labelPeriod() }}</span
        >
    }
}
@if (tabActive === "period") {
    <div
        class="dsn-table dsn-scrollbar scroll-secondary sticky-left sticky-top"
        style="overflow: auto"
        [class.dsn-table--pdf]="pdf"
    >
        <table class="full-width">
            <thead>
                @defer (when !loading()) {
                    @if (options?.comparation?.active) {
                        <tr border="0">
                            <th></th>
                            <th
                                [class.text-12-semi-bold]="!pdf"
                                [class.text-10-semi-bold]="pdf"
                            >
                                {{ columns()[0]?.scenario?.props.name }}
                            </th>
                            @if (options.dre.analysisVertical) {
                                <th></th>
                            }
                            <th
                                [class.text-12-semi-bold]="!pdf"
                                [class.text-10-semi-bold]="pdf"
                            >
                                {{ columns()[1]?.scenario?.props.name }}
                            </th>
                            @if (options.dre.analysisVertical) {
                                <th></th>
                            }
                        </tr>
                    }
                    <tr border="0">
                        <th style="width: 300px"></th>
                        @if (options?.comparation?.active) {
                            <th
                                [class.text-12-semi-bold]="!pdf"
                                [class.text-10-semi-bold]="pdf"
                            >
                                {{ columns()[0]?.dateFormatted }}
                            </th>
                            @if (options.dre.analysisVertical) {
                                <th
                                    [class.text-12-semi-bold]="!pdf"
                                    [class.text-10-semi-bold]="pdf"
                                >
                                    A.V.
                                </th>
                            }
                            <th
                                [class.text-12-semi-bold]="!pdf"
                                [class.text-10-semi-bold]="pdf"
                            >
                                {{ columns()[1]?.dateFormatted }}
                            </th>
                            @if (options.dre.analysisVertical) {
                                <th
                                    [class.text-12-semi-bold]="!pdf"
                                    [class.text-10-semi-bold]="pdf"
                                >
                                    A.V.
                                </th>
                            }
                        } @else {
                            @for (column of columns(); track $index) {
                                <th
                                    [class.text-12-semi-bold]="!pdf"
                                    [class.text-10-semi-bold]="pdf"
                                >
                                    {{ column.dateFormatted }}
                                </th>
                            }
                        }
                    </tr>
                }
            </thead>
            <tbody>
                @defer (when !loading()) {
                    @for (row of rows; track $index) {
                        <tr
                            [class.bold]="row.configs.bold"
                            [class.line-highlight]="row.configs.lineHighlight"
                            [class.text-cyan]="row.configs.textCyan"
                            class="table-row-animation table-row-animation--staggered"
                            [ngStyle]="getRowAnimationStyle($index)"
                        >
                            <td>
                                @if (!options?.comparation?.active) {
                                    <div
                                        class="progress-av"
                                        [ngClass]="
                                            getProgressClasses(
                                                row.av?.pointValue
                                            )
                                        "
                                        [ngStyle]="
                                            getProgressStyle(row.av?.pointValue)
                                        "
                                    ></div>
                                }
                                <div
                                    appMarginLeft
                                    [marginLevel]="row?.configs?.level"
                                    [marginMultiplier]="4"
                                    fxLayout="column"
                                    style="position: relative; z-index: 10"
                                >
                                    <span
                                        [class.text-12-semi-bold]="!pdf"
                                        [class.text-10-semi-bold]="pdf"
                                        >{{ row?.serie?.props?.name }}
                                    </span>
                                    @if (!options?.comparation?.active) {
                                        <span class="text-10-regular"
                                            ><span class="color-text-hint"
                                                >Análise Vertical: </span
                                            ><span
                                                style="
                                                    color: var(
                                                        --color-text-cyan-secondary
                                                    );
                                                "
                                                >{{
                                                    row.av?.pointValueFormatted
                                                }}</span
                                            ></span
                                        >
                                    } @else if (
                                        options.dre.analysisHorizontal
                                    ) {
                                        <span
                                            class="text-10-regular"
                                            fxLayout="row"
                                            fxLayoutAlign="start center"
                                            ><span class="color-text-hint"
                                                >Análise Horizontal: </span
                                            ><span
                                                [class.variation-label--good]="
                                                    row.ah?.polarityColor ===
                                                    'good'
                                                "
                                                [class.variation-label--stable]="
                                                    row.ah?.polarityColor ===
                                                    'stable'
                                                "
                                                [class.variation-label--bad]="
                                                    row.ah?.polarityColor ===
                                                    'bad'
                                                "
                                                [matTooltip]="
                                                    row.ah?.explanation
                                                "
                                                fxLayout="row"
                                                fxLayoutAlign="start center"
                                                style="
                                                    margin-left: var(
                                                        --spacing-4
                                                    );
                                                "
                                                class="gap-4"
                                            >
                                                <i
                                                    class="fa-solid"
                                                    [class.fa-sort-up]="
                                                        row.ah
                                                            ?.variationCondition ===
                                                        1
                                                    "
                                                    [class.fa-sort-down]="
                                                        row.ah
                                                            ?.variationCondition ===
                                                        -1
                                                    "
                                                    [class.fa-minus]="
                                                        row.ah
                                                            ?.variationCondition ===
                                                        0
                                                    "
                                                ></i>
                                                {{
                                                    row.ah?.percentageFormatted
                                                }}</span
                                            ></span
                                        >
                                    }
                                </div>
                            </td>
                            @if (options?.comparation?.active) {
                                <td>
                                    @if (!loading()) {
                                        <span
                                            [appNumberFormatTooltip]="
                                                row.columns[0].pointValue
                                            "
                                            [unit]="
                                                row.serie.props.unit ===
                                                'currency'
                                                    ? 'numberThousand'
                                                    : row.serie.props.unit
                                            "
                                            [defaultDecimals]="
                                                row.serie.props.unit ===
                                                'percentage'
                                                    ? 2
                                                    : pdf
                                                      ? 2
                                                      : 0
                                            "
                                        >
                                            {{
                                                row.columns[0]
                                                    ?.pointValueFormatted
                                            }}
                                        </span>
                                    } @else {
                                        <dsn-skeleton-loader
                                            type="rectangle"
                                            width="60px"
                                            height="16px"
                                            style="
                                                display: block;
                                                width: fit-content;
                                                margin: 0 auto;
                                            "
                                        ></dsn-skeleton-loader>
                                    }
                                </td>
                                @if (options.dre.analysisVertical) {
                                    <td>
                                        @if (!loading()) {
                                            {{
                                                row.avBase?.pointValueFormatted
                                            }}
                                        } @else {
                                            <dsn-skeleton-loader
                                                type="rectangle"
                                                width="60px"
                                                height="16px"
                                                style="
                                                    display: block;
                                                    width: fit-content;
                                                    margin: 0 auto;
                                                "
                                            ></dsn-skeleton-loader>
                                        }
                                    </td>
                                }
                                <td>
                                    @if (!loading()) {
                                        <span
                                            [appNumberFormatTooltip]="
                                                row.columns[1].pointValue
                                            "
                                            [unit]="
                                                row.serie.props.unit ===
                                                'currency'
                                                    ? 'numberThousand'
                                                    : row.serie.props.unit
                                            "
                                            [defaultDecimals]="
                                                row.serie.props.unit ===
                                                'percentage'
                                                    ? 2
                                                    : pdf
                                                      ? 2
                                                      : 0
                                            "
                                        >
                                            {{
                                                row.columns[1]
                                                    ?.pointValueFormatted
                                            }}
                                        </span>
                                    } @else {
                                        <dsn-skeleton-loader
                                            type="rectangle"
                                            width="60px"
                                            height="16px"
                                            style="
                                                display: block;
                                                width: fit-content;
                                                margin: 0 auto;
                                            "
                                        ></dsn-skeleton-loader>
                                    }
                                </td>
                                @if (options.dre.analysisVertical) {
                                    <td>
                                        @if (!loading()) {
                                            {{
                                                row.avComparation
                                                    ?.pointValueFormatted
                                            }}
                                        } @else {
                                            <dsn-skeleton-loader
                                                type="rectangle"
                                                width="60px"
                                                height="16px"
                                                style="
                                                    display: block;
                                                    width: fit-content;
                                                    margin: 0 auto;
                                                "
                                            ></dsn-skeleton-loader>
                                        }
                                    </td>
                                }
                            } @else {
                                @for (column of row.columns; track $index) {
                                    <td>
                                        @if (!loading()) {
                                            <span
                                                [appNumberFormatTooltip]="
                                                    column.pointValue
                                                "
                                                [unit]="
                                                    row.serie.props.unit ===
                                                    'currency'
                                                        ? 'numberThousand'
                                                        : row.serie.props.unit
                                                "
                                                [defaultDecimals]="
                                                    row.serie.props.unit ===
                                                    'percentage'
                                                        ? 2
                                                        : pdf
                                                          ? 2
                                                          : 0
                                                "
                                                >{{
                                                    column.pointValueFormatted
                                                }}</span
                                            >
                                        } @else {
                                            <dsn-skeleton-loader
                                                type="rectangle"
                                                width="60px"
                                                height="16px"
                                                style="
                                                    display: block;
                                                    width: fit-content;
                                                    margin: 0 auto;
                                                "
                                            ></dsn-skeleton-loader>
                                        }
                                    </td>
                                }
                            }
                        </tr>
                    }
                } @placeholder {
                    @for (row of loadingRows; track $index) {
                        <tr>
                            <td>
                                <dsn-skeleton-loader
                                    type="rectangle"
                                    width="80px"
                                    height="16px"
                                ></dsn-skeleton-loader>
                            </td>
                            @for (column of loadingRows; track $index) {
                                <td>
                                    <dsn-skeleton-loader
                                        type="rectangle"
                                        width="80px"
                                        height="16px"
                                    ></dsn-skeleton-loader>
                                </td>
                            }
                        </tr>
                    }
                }
            </tbody>
        </table>
    </div>
} @else {
    <div
        class="dsn-table dsn-scrollbar scroll-secondary sticky-left sticky-top"
        [class.dsn-table--pdf]="pdf"
    >
        <table class="full-width">
            <thead>
                <tr border="0">
                    <th style="width: 300px"></th>
                    <th
                        [class.text-12-semi-bold]="!pdf"
                        [class.text-10-semi-bold]="pdf"
                    >
                        Acumulado
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (row of rows; track $index) {
                    <tr
                        [class.bold]="
                            row.configs.bold &&
                            row.serie.props.unit != 'percentage'
                        "
                        [class.line-main]="
                            row.configs.bold &&
                            row.serie.props.unit != 'percentage'
                        "
                        [class.text-cyan]="
                            row.serie.props.unit === 'percentage'
                        "
                        class="table-row-animation table-row-animation--staggered"
                        [ngStyle]="getRowAnimationStyle($index)"
                    >
                        <td>
                            <div
                                class="progress-av"
                                [ngClass]="
                                    getProgressClasses(row.av?.pointValue)
                                "
                                [ngStyle]="getProgressStyle(row.av?.pointValue)"
                            ></div>
                            <div
                                appMarginLeft
                                [marginLevel]="row?.configs?.level"
                                [marginMultiplier]="4"
                                fxLayout="column"
                                style="position: relative; z-index: 10"
                            >
                                <span>{{ row?.serie?.props?.name }}</span>
                                <span class="text-10-regular"
                                    ><span class="color-text-hint"
                                        >Análise Vertical: </span
                                    ><span
                                        style="
                                            color: var(
                                                --color-text-cyan-secondary
                                            );
                                        "
                                        >{{ row.av?.pointValueFormatted }}</span
                                    ></span
                                >
                            </div>
                        </td>
                        <td>
                            <span
                                [appNumberFormatTooltip]="
                                    row.accumulated.pointValue
                                "
                                [unit]="
                                    row.serie.props.unit === 'currency'
                                        ? 'numberThousand'
                                        : row.serie.props.unit
                                "
                                [defaultDecimals]="
                                    row.serie.props.unit === 'percentage'
                                        ? 2
                                        : pdf
                                          ? 2
                                          : 0
                                "
                            >
                                {{ row.accumulated?.pointValueFormatted }}
                            </span>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
}
